import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideConfig } from '@spartacus/core';
import { productsAuxOccConfig } from './_core/product-aux.occ';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [provideConfig(productsAuxOccConfig)],
})
export class ProductAuxModule {}
